import React from 'react';
import CustomeRowAdd from '../CustomeRowAdd';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { DestinationCheck, LABELS, MODELS, dSystems } from '@src/constants';
import { useSelector } from 'react-redux';
import { RootState } from '@reduxjs/toolkit/query';
import GpsGroup from '../GpsGroup';
import { getThelistData } from '@src/utils';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
interface Drop {
  destinationSystems?: any[];
  profileStatus?: any[];
  profileTypes?: any[];
  secureAccess?: any[];
  marketSegments?: any[];
  complexRatingValues?: any[];
}
const AddCustomer: React.FC = () => {
  const dropDownData = useSelector<RootState, Drop>(
    (state) => state?.listOfValues?.data ?? {}
  );
  const form = useForm();

  const {
    destinationSystems,
    profileStatus,
    profileTypes,
    secureAccess,
    marketSegments,
    complexRatingValues,
    billingTypes,
  } = dropDownData;
  const dsystemSelected = useSelector(
    (state) => state?.destinationSystem?.data
  );
  const marketsegment = form.watch('customerDetails.marketSegment');
  const destination = form.watch('customerDetails.destinationSystem');
  const systemType = getThelistData(destinationSystems, dsystemSelected);
  const isGPSorPRIME =
    destination === DestinationCheck.GPS ||
    destination === DestinationCheck.PRIME;
  const isGPS = destination === DestinationCheck.GPS;
  const marketSeg =
    destination === '8'
      ? marketSegments
      : marketSegments?.filter((item) => item.label !== 'EXCHANGES');
  const gpsData = [
    {
      employerGroupId: '',
      displayBlockNumber: '0',
    },
    {
      employerGroupId: '',
      displayBlockNumber: '1',
    },
    {
      employerGroupId: '',
      displayBlockNumber: '2',
    },
    {
      employerGroupId: '',
      displayBlockNumber: '3',
    },
  ];
  return (
    <Grid.Col
      css={{
        width: '100%',
      }}
    >
      <Card
        css={{
          'abyss-card-root': {
            width: '100%',
            padding: '0',
            borderRadius: '4px',
          },
        }}
      >
        <div
          style={{
            backgroundColor:
              'var(--abyss-colors-web-semantic-color-surface-container-primary)',
            color:
              'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
            minHeight: 'auto',
            paddingTop: '5px',
            paddingBottom: '5px',
            paddingLeft: '24px',
            paddingRight: '24px',
            borderTopLeftRadius: '3px',
            borderTopRightRadius: '3px',
            fontSize: '18px',
            fontWeight: 'bold',
          }}
        >
          Customer Details
        </div>
        <div
          style={{
            paddingTop: '16px',
            paddingBottom: '16px',
            paddingLeft: '24px',
            paddingRight: '24px',
            fontSize: '16px',
            fontWeight: '500',
            display: 'block',
          }}
        >
          <Layout.Group
            css={{
              alignItems: 'start',
            }}
            grow
          >
            <Table.Container title="">
              <Table.TableBody>
                <CustomeRowAdd
                  label={LABELS.ASSIGN_SUBMISSION_ID}
                  model="customerDetails.submitterAssignId"
                />
                {isGPSorPRIME ? null : (
                  <CustomeRowAdd
                    label={LABELS.CUSTOMER_NUMBER}
                    model="customerDetails.customerNumber"
                    maxLength={7}
                  />
                )}
                <CustomeRowAdd
                  label={LABELS.DESTINATION_SYSTEM}
                  model="customerDetails.destinationSystem"
                  type={'select'}
                  options={destinationSystems}
                />
                <CustomeRowAdd
                  label={LABELS.PROFILE_TYPE}
                  model="customerDetails.profileType"
                  type={'select'}
                  options={profileTypes}
                />
                <CustomeRowAdd
                  label={LABELS.COMPLEXITY_RATING}
                  model="customerDetails.complexityRating"
                  type={'select'}
                  options={complexRatingValues}
                />
                <CustomeRowAdd
                  label={LABELS.VERSION_EFFECTIVE_DATE}
                  model="customerDetails.versionEffectiveDate"
                  type={'date'}
                />
                <CustomeRowAdd
                  label={LABELS.SECURITY_ACCESS}
                  model="customerDetails.securityAccess"
                  type={'select'}
                  options={secureAccess}
                />
              </Table.TableBody>
            </Table.Container>
            <Table.Container title="">
              <Table.TableBody>
                <CustomeRowAdd
                  label={LABELS.CUSTOMER_SUBMISSION_NAME}
                  model="customerDetails.submitterGroupName"
                />
                {isGPSorPRIME ? null : (
                  <CustomeRowAdd
                    label={LABELS.POLOCY_NUMBER}
                    model="customerDetails.policyNumber"
                    maxLength={7}
                  />
                )}
                <CustomeRowAdd
                  label={LABELS.LEGAL_ENTITY}
                  model="customerDetails.legalEntity"
                />
                <CustomeRowAdd
                  label={LABELS.PROFILE_STATUS}
                  model="customerDetails.profileStatus"
                  type={'select'}
                  options={profileStatus}
                />
                <CustomeRowAdd
                  label={LABELS.MARKET_SEGMENT}
                  model="customerDetails.marketSegment"
                  type={'select'}
                  options={marketSeg}
                />
                <CustomeRowAdd
                  label={LABELS.VERSION_END_DATE}
                  model="customerDetails.versionEndDate"
                  type={'date'}
                />
                {dsystemSelected === '8' && marketsegment === '4' && (
                  <CustomeRowAdd
                    label="Billing Entity"
                    model="customerDetails.billingEntity"
                    options={billingTypes}
                    type="select"
                  />
                )}
              </Table.TableBody>
            </Table.Container>
          </Layout.Group>
        </div>
        {isGPS && (
          <div style={{ padding: '16px' }}>
            <Layout.Group grow>
              <Table.Container title="">
                <Table.TableBody>
                  <Table.Row>
                    <Table.Cell css={{ width: '250px' }}>
                      <strong>GPS Employer Group Id</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <GpsGroup isAdd={true} />
                    </Table.Cell>
                  </Table.Row>
                </Table.TableBody>
              </Table.Container>
            </Layout.Group>
          </div>
        )}
      </Card>
    </Grid.Col>
  );
};

export default AddCustomer;
